/* ============================================================================
 * COLLECTION PAGE REBUILD - BATCH 3
 *
 * B2 mobile-only behavior:
 *   - Tap-to-reveal safety badge tooltip (preserved)
 *   - Mobile tap-to-swap secondary image was attempted then removed (un-fixable
 *     in this Shopify theme architecture). Mobile cards: tap goes to PDP.
 *
 * B3 desktop additions:
 *   - Horizontal filter dropdown: close-others on open, click-outside to close
 *   - Re-bind on AJAX collection refresh
 *
 * Desktop hover-to-swap continues to work (CSS-driven, no JS needed).
 * ============================================================================ */

(function () {
  function isHoverCapable() {
    return window.matchMedia && window.matchMedia('(hover: hover)').matches;
  }

  /* ----- B2: Badge tap-to-tooltip (mobile) ----- */
  function bindBadge(badge) {
    if (badge.dataset.tooltipInit) return;
    badge.dataset.tooltipInit = '1';
    var hideTimer = null;
    badge.addEventListener('click', function (e) {
      if (isHoverCapable()) return;
      e.preventDefault();
      e.stopPropagation();
      document.querySelectorAll('.safety-badge.is-tooltip-visible').forEach(function (b) {
        if (b !== badge) b.classList.remove('is-tooltip-visible');
      });
      badge.classList.toggle('is-tooltip-visible');
      clearTimeout(hideTimer);
      if (badge.classList.contains('is-tooltip-visible')) {
        hideTimer = setTimeout(function () {
          badge.classList.remove('is-tooltip-visible');
        }, 3000);
      }
    }, true);
  }

  /* ----- B3: Horizontal filter dropdown — close-others on open ----- */
  function bindDropdownGroup(group) {
    if (group.dataset.dropdownInit) return;
    group.dataset.dropdownInit = '1';
    group.addEventListener('toggle', function () {
      if (group.open) {
        var siblings = document.querySelectorAll('details.facets-horizontal__group[open]');
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== group) siblings[i].open = false;
        }
      }
    });
  }

  function init() {
    var badges = document.querySelectorAll('.safety-badge[data-tooltip]');
    for (var j = 0; j < badges.length; j++) bindBadge(badges[j]);

    var groups = document.querySelectorAll('details.facets-horizontal__group');
    for (var k = 0; k < groups.length; k++) bindDropdownGroup(groups[k]);
  }

  /* ----- Click outside dismisses any open horizontal dropdown ----- */
  document.addEventListener('click', function (e) {
    var openGroups = document.querySelectorAll('details.facets-horizontal__group[open]');
    if (openGroups.length === 0) return;
    for (var i = 0; i < openGroups.length; i++) {
      var g = openGroups[i];
      if (!g.contains(e.target)) g.open = false;
    }
  });

  /* ----- B2: Dismiss badge tooltip when tapping outside (mobile only) ----- */
  document.addEventListener('click', function (e) {
    if (isHoverCapable()) return;
    if (!e.target.closest || !e.target.closest('.safety-badge')) {
      document.querySelectorAll('.safety-badge.is-tooltip-visible').forEach(function (b) {
        b.classList.remove('is-tooltip-visible');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:refreshed', init);
  document.addEventListener('facets:applied', init);
  document.addEventListener('section:reloaded', init);
})();